// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalStyle_modalWrp__ffKdx.modalStyle_modalDeleteWrp__fhGBp .modalStyle_modalHeaderImg__aB6ZK {
  background-color: #feeceb;
  border-radius: 500px;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: fit-content;
  margin: 0 auto;
  margin-top: 10px;
}
.modalStyle_modalWrp__ffKdx.modalStyle_modalDeleteWrp__fhGBp .modalStyle_modalHeaderImg__aB6ZK img {
  width: 32px;
  height: 32px;
}
.modalStyle_modalWrp__ffKdx.modalStyle_modalDeleteWrp__fhGBp .modalStyle_modalHeader__3788i p {
  text-align: center;
}
.modalStyle_modalWrp__ffKdx.modalStyle_modalDeleteWrp__fhGBp .modalStyle_modalHeader__3788i h2 {
  text-align: center;
  margin-top: 24px;
  margin-bottom: 6px;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeaderChip__ElCHN {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalInner__8nL46 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 570px;
  width: 95%;
  background-color: var(--bg1);
  border-radius: var(--border-radius-large);
  border: unset;
  max-height: 90dvh;
  display: flex;
  flex-direction: column;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalInner__8nL46:focus-visible {
  outline: none;
}
.modalStyle_modalWrp__ffKdx .modalStyle_closeIcon__vJs6V {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
}
.modalStyle_modalWrp__ffKdx .modalStyle_closeIcon__vJs6V img,
.modalStyle_modalWrp__ffKdx .modalStyle_closeIcon__vJs6V svg {
  width: 100%;
  height: 100%;
  display: block;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeader__3788i {
  padding: 24px 24px 15px 24px;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeader__3788i h2 {
  font: var(--h3);
  font-family: var(--font-bodoni-72);
  color: var(--primary-Text);
  font-weight: 700;
  margin-bottom: 5px;
  text-align: left;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeader__3788i p {
  font: var(--body-font-three);
  color: var(--brand);
  text-align: left;
  margin-top: 8px;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeader__3788i p.modalStyle_subHeading__rIqh8 {
  color: #8692A4;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeaderCentered__Th3M3 {
  text-align: center;
  padding-top: 32px;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeaderCentered__Th3M3 h2 {
  text-align: center;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeaderCentered__Th3M3 p {
  text-align: center;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeaderIcon__3tCsG {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalHeaderIcon__3tCsG svg {
  width: 56px;
  height: 56px;
  display: block;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalBody__758Te {
  flex: 1 1;
  padding: 0 24px;
  overflow-y: auto;
}
.modalStyle_modalWrp__ffKdx .modalStyle_modalFooter__6o1Pc {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  align-items: center;
  padding: 15px 24px 24px 24px;
}

@media screen and (max-width: 767px) {
  .modalStyle_modalWrp__ffKdx .modalStyle_modalHeader__3788i {
    padding: 15px 15px 0 15px;
  }
  .modalStyle_modalWrp__ffKdx .modalStyle_modalFooter__6o1Pc {
    padding: 0 15px 15px 15px;
  }
  .modalStyle_modalWrp__ffKdx .modalStyle_closeIcon__vJs6V {
    width: 30px;
    height: 30px;
    padding: 6px;
  }
  .modalStyle_modalWrp__ffKdx .modalStyle_modalBody__758Te {
    padding: 0 15px;
  }
  .modalStyle_modalWrp__ffKdx .modalStyle_modalFooter__6o1Pc button {
    font-size: 12px;
    min-height: 35px;
    padding: 10px;
  }
}
@media (max-width: 450px) {
  .modalStyle_modalWrp__ffKdx .modalStyle_modalFooter__6o1Pc {
    padding: 10px 15px 15px 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/modal/modalStyle.module.scss"],"names":[],"mappings":"AAEE;EACC,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AADH;AAGG;EACC,WAAA;EACA,YAAA;AADJ;AAOG;EACC,kBAAA;AALJ;AAQG;EACC,kBAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AAWC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AATF;AAYC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,4BAAA;EACA,yCAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAVF;AAYE;EACC,aAAA;AAVH;AAcC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AAZF;AAcE;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AAZH;AAgBC;EACC,4BAAA;AAdF;AAgBE;EACC,eAAA;EACA,kCAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EAEA,gBAAA;AAfH;AAkBE;EACC,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAhBH;AAiBG;EACC,cAAA;AAfJ;AAmBC;EACC,kBAAA;EACA,iBAAA;AAjBF;AAmBE;EACC,kBAAA;AAjBH;AAoBE;EACC,kBAAA;AAlBH;AAsBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AApBF;AAsBE;EACC,WAAA;EACA,YAAA;EACA,cAAA;AApBH;AAwBC;EACC,SAAA;EACA,eAAA;EACA,gBAAA;AAtBF;AAyBC;EACC,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,4BAAA;AAvBF;;AA2BA;EAEE;IACC,yBAAA;EAzBD;EA4BA;IACC,yBAAA;EA1BD;EA6BA;IACC,WAAA;IACA,YAAA;IACA,YAAA;EA3BD;EA8BA;IACC,eAAA;EA5BD;EAgCC;IACC,eAAA;IACA,gBAAA;IACA,aAAA;EA9BF;AACF;AAmCA;EAGE;IACC,4BAAA;EAnCD;AACF","sourcesContent":[".modalWrp {\r\n\t&.modalDeleteWrp {\r\n\t\t.modalHeaderImg {\r\n\t\t\tbackground-color: #feeceb;\r\n\t\t\tborder-radius: 500px;\r\n\t\t\tpadding: 12px;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\tflex-direction: column;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tmargin-top: 10px;\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 32px;\r\n\t\t\t\theight: 32px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t\r\n\t\t.modalHeader {\r\n\t\t\tp {\r\n\t\t\t\ttext-align: center;\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\ttext-align: center;\r\n\t\t\t\tmargin-top: 24px;\r\n\t\t\t\tmargin-bottom: 6px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t\r\n\t.modalHeaderChip{\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: start;\r\n\t\talign-items: center;\r\n\t\tgap: 10px;\r\n\t\tflex-wrap: wrap;\r\n\t}\r\n\t\r\n\t.modalInner {\r\n\t\tposition: absolute;\r\n\t\ttop: 50%;\r\n\t\tleft: 50%;\r\n\t\ttransform: translate(-50%, -50%);\r\n\t\tmax-width: 570px;\r\n\t\twidth: 95%;\r\n\t\tbackground-color: var(--bg1);\r\n\t\tborder-radius: var(--border-radius-large);\r\n\t\tborder: unset;\r\n\t\tmax-height: 90dvh;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\t\r\n\t\t&:focus-visible {\r\n\t\t\toutline: none;\r\n\t\t}\r\n\t}\r\n\t\r\n\t.closeIcon {\r\n\t\tposition: absolute;\r\n\t\ttop: 12px;\r\n\t\tright: 12px;\r\n\t\twidth: 44px;\r\n\t\theight: 44px;\r\n\t\tborder-radius: 50%;\r\n\t\tbackground-color: var(--white);\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tpadding: 12px;\r\n\t\tcursor: pointer;\r\n\t\t\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.modalHeader {\r\n\t\tpadding: 24px 24px 15px 24px;\r\n\t\t\r\n\t\th2 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t\t// text-transform: capitalize;\r\n\t\t\ttext-align: left;\r\n\t\t}\r\n\t\t\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\ttext-align: left;\r\n\t\t\tmargin-top: 8px;\r\n\t\t\t&.subHeading{\r\n\t\t\t\tcolor: #8692A4;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t.modalHeaderCentered {\r\n\t\ttext-align: center;\r\n\t\tpadding-top: 32px;\r\n\r\n\t\th2 {\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\r\n\t\tp {\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t.modalHeaderIcon {\r\n\t\twidth: 56px;\r\n\t\theight: 56px;\r\n\t\tborder-radius: 50%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tmargin: 0 auto 16px auto;\r\n\r\n\t\tsvg {\r\n\t\t\twidth: 56px;\r\n\t\t\theight: 56px;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.modalBody {\r\n\t\tflex: 1;\r\n\t\tpadding: 0 24px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n\t\r\n\t.modalFooter {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\tgap: 12px;\r\n\t\talign-items: center;\r\n\t\tpadding: 15px 24px 24px 24px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\t.modalWrp {\r\n\t\t.modalHeader {\r\n\t\t\tpadding: 15px 15px 0 15px;\r\n\t\t}\r\n\r\n\t\t.modalFooter {\r\n\t\t\tpadding: 0 15px 15px 15px;\r\n\t\t}\r\n\r\n\t\t.closeIcon {\r\n\t\t\twidth: 30px;\r\n\t\t\theight: 30px;\r\n\t\t\tpadding: 6px;\r\n\t\t}\r\n\r\n\t\t.modalBody {\r\n\t\t\tpadding: 0 15px;\t\r\n\t\t}\r\n\r\n\t\t.modalFooter {\r\n\t\t\tbutton {\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t\tmin-height: 35px;\r\n\t\t\t\tpadding: 10px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 450px) {\r\n\t\t\t.modalWrp {\r\n\r\n\t\t.modalFooter {\r\n\t\t\tpadding: 10px 15px 15px 15px;\r\n\t\t}\r\n\t\t}\r\n\t\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrp": `modalStyle_modalWrp__ffKdx`,
	"modalDeleteWrp": `modalStyle_modalDeleteWrp__fhGBp`,
	"modalHeaderImg": `modalStyle_modalHeaderImg__aB6ZK`,
	"modalHeader": `modalStyle_modalHeader__3788i`,
	"modalHeaderChip": `modalStyle_modalHeaderChip__ElCHN`,
	"modalInner": `modalStyle_modalInner__8nL46`,
	"closeIcon": `modalStyle_closeIcon__vJs6V`,
	"subHeading": `modalStyle_subHeading__rIqh8`,
	"modalHeaderCentered": `modalStyle_modalHeaderCentered__Th3M3`,
	"modalHeaderIcon": `modalStyle_modalHeaderIcon__3tCsG`,
	"modalBody": `modalStyle_modalBody__758Te`,
	"modalFooter": `modalStyle_modalFooter__6o1Pc`
};
export default ___CSS_LOADER_EXPORT___;
